export default __webpack_public_path__ + "static/navigating-salesforce-50300c5bef757023a6a2d6391f40e7e3.jpg";